import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { AgGridColumn } from '@ag-grid-community/react';
import DataGrid from '../../common/components/DataGrid';

class TimesheetDailySnapshot extends React.Component {
  render() {
    const { rowData, endDate, onExportReady } = this.props;
    return (
      <DataGrid
        rowData={rowData}
        onExportReady={onExportReady}
        exportFileName={`TimesheetSnapshot-WeekEnding(${endDate})-ExportedOn(${moment(
          new Date(),
        ).format('YYYYMMDD-hhmm')}).csv`}
      >
        <AgGridColumn field="endDate" width={125} />
        <AgGridColumn field="status" width={175} />
        <AgGridColumn field="lastName" />
        <AgGridColumn field="firstName" />
        <AgGridColumn field="payrollId" headerName="Payroll ID" />
        <AgGridColumn field="email" />
        <AgGridColumn field="clientName" width={150} />
        <AgGridColumn field="project" />
        <AgGridColumn field="projectCode" />
        <AgGridColumn field="milestone" />
        <AgGridColumn field="deliverable" />
        <AgGridColumn field="taskdate" width={110} />
        <AgGridColumn field="hours" width={110} />
        <AgGridColumn field="role" />
        <AgGridColumn field="rate" />
        <AgGridColumn field="name" />
        <AgGridColumn field="totalCost" />
        <AgGridColumn field="supervisor" />
        <AgGridColumn field="approvers" />
        <AgGridColumn field="approvedOn" />
        <AgGridColumn field="comment" />
      </DataGrid>
    );
  }
}

export default withRouter(TimesheetDailySnapshot);
